import dropdown from '#utilities/js/lightboxes/menus/dropdown.js'

export default field => {
  dropdown(field)
}